import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-navigation',
	templateUrl:'./WaPageContentsNavigationProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsNavigationProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsNavigationProPage
{
	mdContent_396 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsNavigation;
\`\`\``;
	mdContent_397 = `\`\`\`java
new WaPageContentsNavigation<>()
\`\`\``;
}
